<template>
  <BaseTableItemAction
    v-can:[editPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-pencil"
    actionName="تعديل"
    :to="'/training-programs/' + item.id + '/edit'"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_TPS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      editPermission: WRITE_TPS_PERMISSION,
    };
  },
};
</script>
